import React, {Component} from 'react';
import {connect} from 'dva';

import LoginPageForNew from './routes/LoginPageForNew';
import LoginPageForNewBJZX from './routes/LoginPageForNewBJZX';
import LoginPageForHXYY_ZHYYGLXT from './routes/LoginPageForHXYY_ZHYYGLXT';
import LoginPageForHXYY_KYYZXJFCXXT from './routes/LoginPageForHXYY_KYYZXJFCXXT';
// import LoginPageForNewAHSL from './routes/LoginPageForAHSL';
import VerificationPage from './routes/Verification';

const LOGIN_TYPES = {
  bjzx: LoginPageForNewBJZX,
  hxyy_zhyyglxt: LoginPageForHXYY_ZHYYGLXT,
  hxyy_kyyzxjfcxxt: LoginPageForHXYY_KYYZXJFCXXT,
  // ahsl: LoginPageForNewAHSL,
};

class Login extends Component {

  render() {
    const {systemType} = this.props;
    let DefaultComponent = window.REACT_APP_CONFIG && window.REACT_APP_CONFIG.isFactor ?
      VerificationPage : LOGIN_TYPES[systemType] || LoginPageForNew;
    return (
      <DefaultComponent/>
    );
  }
}

export default connect((state) => {
  return {systemType: state.vadpLogin.systemType};
})(Login);



// WEBPACK FOOTER //
// ./src/Login.js